module.exports = __webpack_public_path__ + "33d88f280c942eafa61f73c84c306dfc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fam/fidelity_investments.png
// module id = 1781
// module chunks = 0